var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCuba(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25e-05 2.78265H0V29.2174H6.25e-05V16.0001V2.78265Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 32.0009C24.8365 32.0009 31.9999 24.8375 31.9999 16.0009C31.9999 7.16442 24.8365 0.00100708 15.9999 0.00100708C7.16342 0.00100708 0 7.16442 0 16.0009C0 24.8375 7.16342 32.0009 15.9999 32.0009Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 0.000183105C10.7657 0.000183105 6.11853 2.51412 3.19946 6.40018H28.8008C25.8818 2.51406 21.2346 0.000183105 16.0002 0.000183105V0.000183105Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 31.9998C21.2347 31.9998 25.8818 29.4859 28.8008 25.5998H3.19946C6.11846 29.4859 10.7657 31.9998 16.0002 31.9998Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00012207 16.0003C0.00012207 17.0962 0.110622 18.1664 0.320559 19.2003H31.6797C31.8897 18.1664 32.0001 17.0962 32.0001 16.0003C32.0001 14.9044 31.8896 13.8342 31.6797 12.8003H0.320559C0.110622 13.8342 0.00012207 14.9044 0.00012207 16.0003V16.0003Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68636 4.68643C-1.56196 10.9347 -1.56196 21.0654 4.68636 27.3139C7.26842 24.7318 9.75167 22.2485 16 16.0002L4.68636 4.68643Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.47572 11.8264L7.5116 15.0149H10.8645L8.15216 16.9856L9.18804 20.1741L6.47572 18.2035L3.76329 20.1741L4.79941 16.9856L2.08704 15.0149H5.43966L6.47572 11.8264Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuba);
export default __webpack_public_path__ + "static/media/cuba.4db1ce38.svg";
export { ForwardRef as ReactComponent };